import SyncableModel from './SyncableModel';

export default class CyclePrediction extends SyncableModel {
    static name = 'CyclePrediction'

    _fillable = [
      'id', 'cycle_id', 'age', 'date',
      'weight', 'size', 'actual_mortality', 'actual_mortality_accumulation', 'mortality', 'mortality_accumulation', 'total_tails',
      'harvest', 'harvest_accumulation', 'total_weight', 'harvest_weight', 'harvest_accumulation_weight',
      'feed',
      'fasting',
      'feed_accumulation', 'survival_rate', 'fcr',
      'adg', 'size_price', 'selling_price', 'potential_revenue', 'revenue_accumulation', 'feed_cost', 'rough_total_cost', 'cogs', 'profit',
      'created_at', 'updated_at', 'deleted_at', 'synced_at', 'shrimp_price_currency'
    ]

    _keyType = 'string'

    static endpoint = '/cycle_predictions'

    static allowReplaceUpdate = true

    static syncOnly = true
}
